<template>
    <div class="content">
        <div class="head">
            <p class="headP">
                <span class="headQIouou">七鸥鸥</span>
                <span class="headHotel">商家管理系统</span>
                <span class="headUser">已有账号?</span>
                <span class="headRegister" @click="login">立即登陆</span>
            </p>
        </div>
        <div class="body">

            <div class="bodyTitle">
                <el-steps :active="1" align-center class="bodyStep">
                    <el-step title="注册账号" ></el-step>
                    <el-step title="入住商户" ></el-step>
                    <el-step title="提交信息" ></el-step>
                    <el-step title="等待审核" ></el-step>
                    <el-step title="审核通过" ></el-step>
                </el-steps>
    
            <div class="bodyTail">
                <p class="tailP">你需要先注册成为七鸥鸥商家管理系统的用户，每个邮箱仅能关联一个账号</p>
                <hr/>
                <component :is="componentType" />
            </div>

            </div>
            
        </div>
    </div>
</template>

<script>
import RegisterInfo from './RegisterInfo'//注册
import Merchant from './Merchant'//商户类型
import MerchantInfo from './MerchantInfo' //提交商户信息
import Audit from './Audit' //审核中
import AuditFinish from './AuditFinish' //审核通过

export default {
    data(){
        return{
           user:'',
           password:'',
           componentType:'AuditFinish',
        }
    },
    components: {RegisterInfo,Merchant,MerchantInfo,Audit,AuditFinish},  
    methods:{
        login(){
            this.$router.replace('/')
        }
    }
    
}
</script>

<style scoped>
.content{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  height: 1000px;
  
}

.head{
    background-color: #409EFF;
    height: 8%;
}
.headP{
    padding-top: 1%;
}

.body{
    background-color:#FFFFFF;
    height: 90%;
}

.headQIouou{
    color: aliceblue;
    font-weight: 800;
    font-family: '华文行楷';
    font-size: 50px;
}
.headHotel{
    margin-right: 70%;
    color: aliceblue;
    font-size: 20px;
}
.headUser{
    color: aliceblue;
    font-size: 20px;
}
.headRegister{
    color:#FFCC00;
    font-size: 20px;
}


.bodyTitle{
    height: 100%;
    background-color: #F2F6FC;
}
.bodyStep{
    padding-top: 2%;
}
.bodyTail{
    background-color: #FFFFFF;
    width: 90%;
    margin-left: 5%;
    height: 85%;
}

.tailP{
    color: #409EFF;
    padding-top: 2%;
}

</style>


// WEBPACK FOOTER //
// src/components/Register/Register.vue